const SEPARATOR = '.';
export const processFlagNames = (flags = []) =>
    Object.entries(flags).reduce(
        (result, [flagName, value]) => ({
            ...result,
            [flagName
                .replace(/^ff-/, '')
                .replace(/^-/, '')
                .replace(/(-){2,}/g, SEPARATOR)
                .replace(/-/g, SEPARATOR)]: value,
        }),
        {},
    );

export default function processFeatureFlagsAndABTest(flags) {
    const newFlags = processFlagNames({ ...flags });
    if (Object.keys(newFlags).length > 0) {
        Object.entries(newFlags).forEach(([key, value]) => {
            if (value !== 'default') {
                if (['b', 'feature_b', 'ON'].includes(value)) {
                    newFlags[key] = true;
                } else if (['a', 'feature_a', 'OFF'].includes(value)) {
                    newFlags[key] = false;
                } else {
                    newFlags[key] = value;
                }
            } else {
                newFlags[key] = false;
            }
        });
    }
    return newFlags;
}
